/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, ClassNames } from '@emotion/react'
import { TableCell } from '@mui/material'
import cn from 'classnames'
import { Cell, TableCellProps } from 'react-table'
import { ACTION_COLUMN_ID, CELL_PADDING } from '../DataTable'

interface Props<D extends object> {
  cell: Cell<D>
  cellProps: Omit<TableCellProps, 'key'>
}

export default function BodyCell<D extends object>({ cell, cellProps }: Props<D>) {
  const { style, className, ...restOfCellProps } = cellProps
  const isActionColumn = cell.column.id === ACTION_COLUMN_ID

  return (
    <ClassNames>
      {({ css, cx }) => (
        <TableCell
          css={cx(
            // @ts-ignore
            css(style),
            css`
              && {
                padding: ${CELL_PADDING}px;
                display: block;
                border-bottom: none;
                ${isActionColumn ? 'flex: none;' : ''}
              }
            `
          )}
          className={cn(className, isActionColumn ? 'cell-ActionColumn' : undefined)}
          {...restOfCellProps}
          component="div"
          variant="body"
        >
          {/** @ts-ignore */}
          {cell.render('Cell')}
        </TableCell>
      )}
    </ClassNames>
  )
}
